__turbopack_context__.v({
  "button": "ToggleButton-module-scss-module__RznYGW__button",
  "ghost": "ToggleButton-module-scss-module__RznYGW__ghost",
  "l": "ToggleButton-module-scss-module__RznYGW__l",
  "m": "ToggleButton-module-scss-module__RznYGW__m",
  "outline": "ToggleButton-module-scss-module__RznYGW__outline",
  "s": "ToggleButton-module-scss-module__RznYGW__s",
  "selected": "ToggleButton-module-scss-module__RznYGW__selected",
});
